'use client'

import { LanguageDropdown } from '@/components/language-dropdown'
import { FullscreenToggle } from '@/components/layout/full-screen-toggle'
import { UserDropdown } from '@/components/layout/user-dropdown'
import { ModeDropdown } from '@/components/mode-dropdown'
import { ToggleMobileSidebar } from '../toggle-mobile-sidebar'

export function BottomBarHeader() {
  return (
    <div className="container flex h-14 justify-between items-center gap-4">
      <ToggleMobileSidebar />
      <div className="flex gap-2">
        <FullscreenToggle />
        <ModeDropdown />
        <LanguageDropdown />
        <UserDropdown />
      </div>
    </div>
  )
}
